function BuildingHeaderLoading() {
    return (
        <div className="baseline-building-report-header" style={{ height: "150px" }}>
            <div style={{ display: "grid", gap: "16px", width: "100%" }}>
                <div
                    style={{
                        width: "30%",
                        height: "16px",
                        borderRadius: "8px",
                    }}
                    className="loading"
                />
                <div
                    style={{
                        width: "20%",
                        height: "16px",
                        borderRadius: "8px",
                    }}
                    className="loading"
                />
            </div>
            <div
                style={{
                    width: "20%",
                    height: "16px",
                    borderRadius: "8px",
                }}
                className="loading"
            />
        </div>
    );
}

export default BuildingHeaderLoading;
